<template>
    <!-- sizes, prev, pager, next, jumper, ->, total, slot   'prev, pager, next, jumper, ->, total' -->

    <!-- <el-pagination background :current-page.sync="params.pageIndex"
        :page-size.sync="params.pageSize" :total="total" layout="prev, pager, next"
        @page-change="getData"
        style="height: 50px;align-items: center;display: flex;justify-content: flex-end;padding-right:20px">
    </el-pagination> -->
    <vxe-pager perfect :current-page.sync="params.pageIndex" :page-size.sync="params.pageSize"
        :total="total" :page-sizes="[20, 50, 100,1000]"
        :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump',  'FullJump', 'Total']"
        @page-change="getData">
        <template #left>
            <!-- <vxe-button size="small" @click="getData"> -->
            <!-- <template #default>
                    <i :class="{'el-icon-refresh':!loading,'el-icon-loading':loading}"></i>
                </template> -->
            <!-- </vxe-button> -->
        </template>
    </vxe-pager>
</template>
<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getData() {
      this.$emit("getData");
    },
  }
};

</script>
